'use client';

import dynamic from 'next/dynamic';
import { createPortal } from 'react-dom';

import { useLayoutState } from '@/components/layout/Providers/LayoutContext';
import { LAYOUT_NAV_ITEMS } from '@/constants/index';

import ProProgramTermsModal from '../ProProgramTermsModal';

const SizeGuideModal = dynamic(
  () => import('@/components/layout/Modals/SizeGuideModal'),
  { ssr: false },
);

const BlogFiltersModal = dynamic(
  () => import('@/components/blog/BlogFilters/BlogFiltersModal'),
  { ssr: false },
);

const MODAL_MAP = {
  [LAYOUT_NAV_ITEMS.PDP_SIZE_GUIDE]: SizeGuideModal,
  [LAYOUT_NAV_ITEMS.PRO_PROGRAM_TERMS]: ProProgramTermsModal,
  [LAYOUT_NAV_ITEMS.BLOG_FILTERS]: BlogFiltersModal,
};

const ModalResolver = () => {
  const { activeModalPath, modalData } = useLayoutState();

  if (typeof document === 'undefined') return null;

  if (!activeModalPath) return null;

  const ModalComponent = MODAL_MAP[activeModalPath];

  if (!ModalComponent) return null;

  return createPortal(
    <ModalComponent modalData={modalData} />,
    document.body,
  );
};

export default ModalResolver;
